import { authorizedApi } from './index';

export const zyptoPrepaidCardsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    initiatePrepaidCard: builder.mutation({
      query: ({ amount }) => ({
        url: '/zypto/prepaid-cards/initiate',
        method: 'POST',
        body: {
          amount,
        },
      }),
    }),
    broadcastAndCreatePrepaidCard: builder.mutation({
      query: ({ serializedTransaction, cardId }) => ({
        url: '/zypto/prepaid-cards/broadcast-and-create',
        method: 'POST',
        body: {
          serializedTransaction,
          cardId,
        },
      }),
    }),
    listPrepaidCards: builder.query({
      query: () => ({
        url: '/zypto/prepaid-cards',
        method: 'GET',
      }),
    }),
    getPrepaidCardStatus: builder.query({
      query: (cardId) => ({
        url: `/zypto/prepaid-cards/${cardId}/status`,
        method: 'GET',
      }),
    }),
    createOrderDeposit: builder.mutation({
      query: ({ amount, currency, tokenSymbol, productId, email }) => ({
        url: '/zypto/prepaid-cards/create-order-deposit',
        method: 'POST',
        body: {
          amount,
          currency,
          tokenSymbol,
          productId,
          email,
        },
      }),
    }),
    prepareDeposit: builder.mutation({
      query: (cardId) => ({
        url: `/zypto/prepaid-cards/${cardId}/prepare-deposit`,
        method: 'POST',
      }),
    }),
    checkFee: builder.mutation({
      query: ({ amount }) => ({
        url: `/zypto/prepaid-cards/check-fee`,
        method: 'POST',
        body: {
          amount,
        },
      }),
    }),
    broadcastDeposit: builder.mutation({
      query: ({ cardId, serializedTransaction }) => ({
        url: `/zypto/prepaid-cards/${cardId}/broadcast-deposit`,
        method: 'POST',
        body: {
          serializedTransaction,
        },
      }),
    }),
  }),
});

export const {
  useInitiatePrepaidCardMutation,
  useBroadcastAndCreatePrepaidCardMutation,
  useListPrepaidCardsQuery,
  useGetPrepaidCardStatusQuery,
  useCreateOrderDepositMutation,
  usePrepareDepositMutation,
  useCheckFeeMutation,
  useBroadcastDepositMutation,
} = zyptoPrepaidCardsApi;
